export const accentColor = '#1C8ACB';
export const accentDarkColor = '#37647F';
export const accentDarkerColor = '#2F5C77';

// MARK: - Side panel
export const sidePanelBackGroundColor = '#27292C';
export const sidePanelHighlightColor = '#1A1B1D';
export const sidePanelTopColor = '#222426';

// MARK: - Navigation bar
export const navigationBarColor = '#f7f7f7';

export const viewControllerBackgroundColor = '#f8f8f8';

export const assignedCoursesBackground = '#469BCE';
export const enrolledCoursesBackground = '#FBAF17';
export const exploreLibraryBackground = '#1DBC9C';

export const actionBarColor = '#182D3C';
// export const actionBarColor = '#4285f4';
export const actionBarDarkColor = '#102331';

export const commentVCBackgroundColor = '#ffffff';
export const commentCellColor = '#e0e0e0';
export const commentCellBorderColor = '#e0e0e0';
export const commentSendColor = '#56a203';
export const commentInputPlaceHolderTextColor = '#d0d0d0';
export const androidRecommendCardBgColor = '#fdfdfd';
export const recommendedCardBorderColor = '#e0e0e0';

export const completedGreenColor = '#56a203';
export const resubmitRedColor = '#D90000';

export const toastViewBackgroundColor = '#373737';
export const toastViewButtonColor = '#FFEC00';
export const optionsBackgroundColor = '#f8f8f8';
export const audioPlayerBackgroudColor = '#0a0a0a';
export const audioPlayerSeekbarColor = '#393D3E';
export const audioPlayerTextColor = '#B9BABC';

export const curriculumGroupCellBackground = '#f4f4f4';
export const responseTypeLabel = '#CDCDCD';
export const curriculumListSeperatorColor = '#000000';
export const courseOrangeColor = '#FBAF17';
export const courseProgressBarBackgroundColor = 'rgba(70, 87, 113, 0.81)';
export const courseTextBackground = 'rgba(0, 0, 0, 0.24)';
export const searchBarBackground = 'rgba(255, 255, 255, 0.24)';
export const searchBarPlaceholderTextColor = 'rgba(255, 255, 255, 0.54)';
export const activeTabFontColor = 'black';
export const inactiveTabFontColor = 'rgba(0, 0, 0, 0.54)';

export const seperator26opacityblack = 'rgba(0, 0, 0, 0.26)';

export const loginTransparentBackground = 'rgba(255, 255, 255, 0.26)';
export const white87 = 'rgba(255, 255, 255, 0.87)';
export const white48 = 'rgba(255, 255, 255, 0.48)';
export const white36 = 'rgba(255, 255, 255 ,0.36)';
export const white18 = 'rgba(255, 255, 255, 0.18)';
export const white54 = 'rgba(255, 255, 255, 0.54)';
export const androidwhite54 = '#54636E';

export const white = 'white';
export const lineColor = 'rgba(0, 0, 0, 0.12)';
export const commentBubbleTintColor = '#ffffff'; // 4abafb
export const commentBubbleReceiveTintColor = '#4abafb'; // d2d2d7
export const companySelectionDarkBlue = '#182d3c';
export const correctAnswerGreenColor = '#5E9324';
export const incorrectAnswerRedColor = '#D90000';

export const black12 = 'rgba(0,0,0,0.12)';
export const black26 = 'rgba(0,0,0,0.26)';
export const black54 = 'rgba(0,0,0,0.54)';
export const black87 = 'rgba(0,0,0,0.87)';
export const black50 = 'rgba(0,0,0,0.5)';

export const optionSelectedColor = '#FDD78B';

export const errorMessageColor = 'red';
export const red = 'red';
export const shadowColor = '#777777';
